// Marks support tickets as read when clicked from Business Pulse unified list

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    ticketId: String
  }

  async markAsRead() {
    const url = `/support/tickets/${this.ticketIdValue}/mark-read`

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': this.getMetaValue('csrf-token'),
          Accept: 'text/vnd.turbo-stream.html'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      if (html) {
        Turbo.renderStreamMessage(html)
        document.dispatchEvent(new CustomEvent('unified-item:removed'))
      }
    } catch (error) {
      console.error('Error marking ticket as read:', error)
    }
  }

  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="csrf-token"]`)
    return element.getAttribute('content')
  }
}
